import { Component } from '@angular/core';

@Component({
  selector: 'app-background',
  imports: [],
  templateUrl: './background.component.html',
  styles: ``
})
export class BackgroundComponent {

}
